/**
 * Title Toggle in SP
 */
const distinguishToggle = () => {
  const sp = 766;
  if (window.innerWidth <= sp) {
    const itemBlocks = document.querySelectorAll('.distinguish__block');
    //@ts-ignore
    itemBlocks.forEach((item) => {
      const titleBlock = item.querySelector('.section__title-type3');
      const imgBlock = item.querySelector('.distinguish__img-block');
      const carretIcon = item.querySelector('.section__carret-icon');
      const hideButton = item.querySelector('.section__hide-btn');

      titleBlock?.addEventListener('click', () => {
        imgBlock?.classList.toggle('active');
        carretIcon?.classList.toggle('active');
      });

      hideButton?.addEventListener('click', () => {
        imgBlock?.classList.remove('active');
        carretIcon?.classList.remove('active');
      });
    });

    const searchvar = window.location.hash.substr(1);
    if (searchvar) {
      const item = document.querySelector('[block-id=' + searchvar + ']');
      item?.classList.toggle('active');
    }

    itemBlocks.forEach(element => {
      if (element.getAttribute('block-id') == searchvar) {
        const imgBlock = element.querySelector('.distinguish__img-block');
        const carretIcon = element.querySelector('.section__carret-icon');

        imgBlock?.classList.add('active');
        carretIcon?.classList.add('active');
      }
    });
  }
};

export default distinguishToggle;
